<a class="menuLeftItem text-yellow-300" (click)="session.resetCampaignData(); editUser()">Edit Account</a>
<!--  -->
@if (isAdmin || isSkyMarshal) {
  <a class="menuLeftItem text-yellow-300" routerLink="/campaign/0/edit" routerLinkActive="ngActiveLinkWhite" (click)="session.closeMobileMenus($event)">New Campaign</a>
}

@if (isAdmin) {
  <a class="menuLeftItem text-yellow-300" (click)="session.testingOnClick()">Testing</a>
  <!-- Testing Dropdown Menu -->
  <!-- Reminder: Both desktop & mobile share the SAME menu -->
  @if (session.menuTestingVisible) {
    <div id="_testing-menu_" class="px-6 menuLeftItem text-yellow-300">
      <menu-items-testing class="w-full flex flex-col"></menu-items-testing>
    </div>
  }

  <a routerLink="/user/user-list" class="menuLeftItem text-yellow-300" (click)="session.closeMobileMenus($event)">Users</a>
}
<!--  -->
<a (click)="logout()" class="menuLeftItem text-yellow-300">Logout</a>
